export function buyerAdvisoryVacantLandCP826() {
return [   // Release 2026-09-03 14:23:58
 
{
   page: 0,
   name: "Agent Brokerage Firm Name 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 159.36,
   width: 378.60,
   height: 10.08
}
,
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 175.2,
   left: 180.12,
   width: 356.28,
   height: 10.08
}
,
{
   page: 0,
   name: "Buyer Broker and CoAgent Names", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 201.96,
   left: 180.12,
   width: 356.28,
   height: 10.08
}
,
{
   page: 0,
   name: "Agent Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 228.96,
   left: 180.12,
   width: 356.28,
   height: 10.08
}
,
{
   page: 0,
   name: "Agent Brokerage Firm Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
,
{
   page: 1,
   name: "Agent Brokerage Firm Name 3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 159.36,
   width: 378.60,
   height: 10.08
}
,
{
   page: 1,
   name: "Agent Brokerage Firm Name 4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
,
{
   page: 2,
   name: "Agent Brokerage Firm Name 5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 159.36,
   width: 378.60,
   height: 10.08
}
,
{
   page: 2,
   name: "Agent Brokerage Firm Name 6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
,
{
   page: 3,
   name: "Agent Brokerage Firm Name 7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 159.36,
   width: 378.60,
   height: 10.08
}
,
{
   page: 3,
   name: "Agent Brokerage Firm Name 8", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
,
{
   page: 4,
   name: "Agent Brokerage Firm Name 9", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 159.36,
   width: 378.60,
   height: 10.08
}
,
{
   page: 4,
   name: "Agent Brokerage Firm Name 10", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
,
{
   page: 5,
   name: "Agent Brokerage Firm Name 11", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 159.36,
   width: 378.60,
   height: 10.08
}
,
{
   page: 5,
   name: "Agent Brokerage Firm Name 12", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
,
{
   page: 6,
   name: "Agent Brokerage Firm Name 13", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 47.4,
   left: 159.36,
   width: 378.60,
   height: 11.16
}
,
{
   page: 6,
   name: "Signature Buyer Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 392.48,
   left: 72.0,
   width: 378.24,
   height: 15.054
}
,
{
   page: 6,
   name: "Date Signature Buyer Broker", 
   fontSize: 9,
   type: "date",
   top: 392.48,
   left: 455.28,
   width: 76.68,
   height: 15.054
}
,
{
   page: 6,
   name: "Signature Buyer CoAgent", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 439.84,
   left: 72.0,
   width: 378.24,
   height: 15.054
}
,
{
   page: 6,
   name: "Date Signature Buyer CoAgent", 
   fontSize: 9,
   type: "date",
   top: 439.84,
   left: 455.28,
   width: 76.68,
   height: 15.054
}
,
{
   page: 6,
   name: "Agent Brokerage Firm Name 14", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
] }
